module.exports = __webpack_public_path__ + "img/Marshall Islands.3171e40d.svg";